import React, { useContext, useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import LocationContext from "../../../context/location/LocationContext";
import { languagesUSCA } from "../../../utils/languageCodes";
import { timeZonesUS } from "../../../utils/timeZones";
import BackButton from "../../common/BackButton";
import Spinner from "../../layout/Spinner";
import LocationScreenList from "../location/LocationScreenList";

const MyLocationItem = () => {
  const { id: locationId } = useParams();
  const navigate = useNavigate(); 

  const locationContext = useContext(LocationContext);
  const { error, loading, current, getLocation, clearCurrent } = locationContext;

  const [location, setLocation] = useState({
    name: "",
    _id: undefined,
    language: "",
    timeZone: "",
    locationIdentifier: "",
    isActive: "",
    isEnabled: "",
    screens: [],
    mctEnabled: "",
    alternateCountdown: ""
  });

  const handleLocation = (loc) => {
    setLocation({ ...current, ...loc });
  };

  useEffect(() => {
    if (!current && locationId) {
      getLocation(locationId);
    }

    handleLocation(current);

    // Refresh location data every 45 seconds
    const interval = setInterval(() => {
      if (locationId) getLocation(locationId);
    }, 45 * 1000);

    return () => clearInterval(interval);
    // eslint-disable-next-line
  }, [error, current, loading]);

  // On unmount
  useEffect(() => {
    return () => clearCurrent();
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {current && !loading ? (
        <>
          <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
            <h2>{location.name}</h2>
            <div className="btn-group">
              <BackButton url={-1} /> 
            </div>
          </div>

          <div className="form-row">
            <div className="form-group col-6">
              <label>Name</label>
              <input
                type="text"
                name="name"
                className="form-control"
                value={location.name || ""}
                disabled
                required
              />
            </div>
            <div className="form-group col-6">
              <label>Studio Number</label>
              <input
                className="form-control"
                type="text"
                name="locationIdentifier"
                value={location.locationIdentifier || ""}
                disabled
                required
              />
            </div>
          </div>

          <div className="row">
            <div className="form-group col-3">
              <label>Time Zone</label>
              <select
                name="timeZone"
                className="form-control"
                value={location.timeZone || ""}
                disabled
                required
              >
                <option></option>
                {timeZonesUS.map((tz, i) => (
                  <option key={i} value={tz}>
                    {tz}
                  </option>
                ))}
              </select>
            </div>

            <div className="form-group col-3">
              <label>Language</label>
              <select
                className="form-control"
                name="language"
                value={location.language || ""}
                disabled
                required
              >
                <option></option>
                {languagesUSCA.map((lang, i) => (
                  <option key={i} value={lang}>
                    {lang}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <LocationScreenList locked={true} location={location} />
        </>
      ) : (
        <Spinner />
      )}
    </>
  );
};

export default MyLocationItem;
